import localFont from 'next/font/local';

const primary = localFont({
  src: [
    {
      path: './fonts/PantonNarrow-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './fonts/PantonNarrow-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './fonts/PantonNarrow-Black.woff2',
      weight: '800',
      style: 'normal',
    },
  ],
  variable: '--font-primary',
  preload: false,
});

export const fonts = {
  primary,
};
